import React from 'react';
import { RoleListItem } from 'src/components/roles/list/types';
import { DeleteModals } from 'src/components/roles/list/table/columns/actions/delete';
import { RoleAction } from 'src/components/roles/list/table/columns/actions/types';

export const ActionModals = ({
  action,
  onClose,
  role,
  onActionFinished,
}: {
  action: RoleAction;
  onClose: () => void;
  role: RoleListItem;
  onActionFinished?: (action: RoleAction) => void;
}) => {
  const onFinished = () => {
    onActionFinished?.(action);
    onClose();
  };

  return (
    <DeleteModals
      action={action}
      role={role}
      onClose={onClose}
      onFinished={onFinished}
    />
  );
};
